import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export type GuestMessage = {
  id: string;
  role: "user" | "assistant";
  content: string;
  sources?: string[];
  latencyMs?: number;
  createdAt: number; // unix ms (client-side)
};

type GuestState = {
  messages: GuestMessage[];
  thinking: boolean;
  append: (m: GuestMessage) => void;
  setThinking: (t: boolean) => void;
  reset: () => void;
};

export const useGuest = create<GuestState>()(
  persist(
    (set) => ({
      messages: [],
      thinking: false,
      append: (m) => set((s) => ({ messages: [...s.messages, m] })),
      setThinking: (t) => set({ thinking: t }),
      reset: () => set({ messages: [], thinking: false }),
    }),
    {
      name: "submitterai.guestConversation",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (s) => ({ messages: s.messages }),
    },
  ),
);

export function newGuestMessageId() {
  return `g_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
}
